import {RegexValidator} from "./RegexValidators";
import {AbsctractValidator} from "./AbstractValidator";
import {MaximumLengthValidator, MinimunLengthValidator} from "./LengthValidators";

export class EmailValidator extends RegexValidator {
    constructor(input) {
        const regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        super(input, regex);
    }
    isValid() {
        if (this.input.length > 3) {
            this.input = this.input.toLowerCase();
            return this.regex.test(this.input);
        }
        return false;
    }
    message() {
        return !this.isValid() ? "E-mail inválido" : "OK";
    }
}

export class CpfValidator extends RegexValidator {
    constructor(input) {
        const regex = new RegExp("^\\d{11}$");
        super(input, regex);
    }
    isValid() {
        let allDigitsSame = true;
        for (let i = 1; i < this.input.length; i++) {
            if (this.input.charAt(i) !== this.input.charAt(i - 1)) {
                allDigitsSame = false;
                break;
            }
        }
        if(this.input && this.input.toString().length === 11 && !allDigitsSame) {
            let add, rev;
            // Valida 1o digito
            add = 0;
            for(let i = 0; i < 9; i++) {
                add += parseInt(this.input.toString().charAt(i), 10) * (10 - i);
            }
            rev = 11 - (add % 11);
            rev = rev === 10 || rev === 11 ? 0 : rev;
            if(rev === parseInt(this.input.toString().charAt(9), 10)) {
                // Valida 2o digito
                add = 0;
                for(let i = 0; i < 10; i++) {
                    add += parseInt(this.input.toString().charAt(i), 10) * (11 - i);
                }
                rev = 11 - (add % 11);
                rev = rev === 10 || rev === 11 ? 0 : rev;
                if(rev === parseInt(this.input.toString().charAt(10), 10)) {
                    return true;
                }
            }
        }
        return false;
    }
    message() {
        return !this.isValid() ? "Número de CPF inválido" : "OK";
    }
}

export class AgeValidator extends AbsctractValidator {
    constructor(input, min, max) {
        super(input);
        this.minAge = min;
        this.maxAge = max;
    }
    isValid() {
        if(this.input && this.minAge && this.maxAge) {
            let today = new Date();
            let minToday = new Date(today.getFullYear() - this.minAge, today.getMonth() + 1, today.getDate());
            let maxToday = new Date(today.getFullYear() - this.maxAge, today.getMonth() + 1, today.getDate());
            let year, month, day;
            let value = this.input.replace(/[^0-9]/g, "");
            year = value.slice(4,8);
            month = value.slice(2, 4);
            day = value.slice(0, 2);
            let date = new Date(year, month - 1, day);
            date = date.getTime();
            return date > maxToday && date < minToday;
        }
        return false;
    }
    message() {
        return !this.isValid() ? "Idade deve ser entre " + this.minAge + " e " + this.maxAge + " anos": "OK";
    }
}

export class PhoneValidator extends AbsctractValidator {
    isValid() {
        let input = this.input.replace(/[^0-9]/g, '');
        let minlength = new MinimunLengthValidator(input, 10);
        let maxLength = new MaximumLengthValidator(input, 11);
        if(input.length === 11) {
            return minlength.isValid() && maxLength.isValid() && input.charAt(2) === "9";
        }
        return minlength.isValid() && maxLength.isValid();
    }
    message() {
        return !this.isValid() ? "Telefone inválido" : "OK";
    }
}


// WEBPACK FOOTER //
// ./src/validator/PersonValidators.js